import { useEffect } from 'react';

import { ia } from 'lib/helpers/utility';

const useOutsideClick = (ref, handler) => {
  useEffect(() => {
    // Normalize ref to always be an array for consistent handling
    const refs = ia(ref) ? ref : [ref];

    // Early return if no valid refs exist
    if (refs.length === 0 || refs.every((r) => !r?.current)) return;
    const listener = (event) => {
      // Check if click is inside any of the refs
      const isInsideAnyRef = refs.some((r) => r?.current?.contains(event.target));

      if (isInsideAnyRef) {
        return;
      }

      handler(event);
    };

    document.addEventListener('click', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('click', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export default useOutsideClick;
